// extracted by mini-css-extract-plugin
module.exports = {"xs":"320","sm":"390","md":"768","lg":"1128","pill-wrapper":"Pill_pill-wrapper__s1rSv","pill":"Pill_pill__ing8I","pill-inner":"Pill_pill-inner__6z3OS"};